import Symbol           from 'es6-symbol/polyfill';
import EventEmitter     from 'events';
import axios            from 'axios';
import SearchService from '@/front/services/search';

let singleton = Symbol();
let singletonEnforcer = Symbol();

class NoticesService extends EventEmitter {

  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this._instance = axios.create();
    this._cancelTokenAutocomplete = axios.CancelToken;
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new NoticesService(singletonEnforcer);
    }
    return this[singleton];
  }
  getMostViews() {
    const seq = axios.get('/api/v2/notices/most-viewed', {
      params: {
        'order[views]': 'desc',
      }
    })
    seq.catch( console.error );
    return seq;
  }
  getAutocomplete(query) {
    if(this.cancelAutocomplete) this.cancelAutocomplete();
    const seq = this._instance({
      url: '/api/v2/notices/search-autocomplete',
      method: 'get',
      cancelToken: new this._cancelTokenAutocomplete((c) => {
        this.cancelAutocomplete = c;
      }),
      params: {
        query,
        page: 1,
        items_per_page: 5,
        onlineFilter: 'online'
      }
    })
    seq.catch( console.error );
    return seq;
  }

  getAll() {
    this.emit('searching', true);
    const seq = axios.get('/api/v2/notices/search', {params: { ...SearchService.paramsNotices } });
    seq.then((res) => {
      this.emit('updated', res.data);
      this.emit('searching', false);
    }).catch( console.error )
    return seq;
  }
}
export default NoticesService.getInstance();